/**
 * Font / script fixtures for visual QA (7a).
 * Samples must render without tofu □ or mangled diacritics.
 */
export function FontFixturesPage() {
  const samples = [
    {
      id: 'bcs',
      lang: 'bs',
      dir: 'ltr' as const,
      label: 'BCS Latin (č ć š ž đ)',
      lines: ['Dobrodošli', 'račun', 'višejezični', 'čćšžđ ČĆŠŽĐ'],
    },
    {
      id: 'cyrl',
      lang: 'sr',
      dir: 'ltr' as const,
      label: 'Cyrillic',
      lines: ['Српски добро', 'Ћирилица ради', 'добродошли'],
    },
    {
      id: 'ar',
      lang: 'ar',
      dir: 'rtl' as const,
      label: 'Arabic (RTL)',
      lines: ['العربية', 'مرحباً بك في 7GC Mail', 'صندوق الوارد'],
    },
    {
      id: 'ja',
      lang: 'ja',
      dir: 'ltr' as const,
      label: 'Japanese (CJK)',
      lines: ['日本語', 'メールへようこそ', '受信トレイ'],
    },
    {
      id: 'zh',
      lang: 'zh-Hans',
      dir: 'ltr' as const,
      label: 'Chinese Simplified',
      lines: ['中文', '欢迎使用 7GC Mail', '收件箱'],
    },
    {
      id: 'hi',
      lang: 'hi',
      dir: 'ltr' as const,
      label: 'Devanagari',
      lines: ['हिन्दी', '7GC मेल में आपका स्वागत है'],
    },
  ]

  return (
    <section className="font-fixtures card">
      <h1>Font fixtures</h1>
      <p className="muted">
        Self-hosted Inter + Noto (CSP <code>font-src &apos;self&apos;</code>). No CDN.
      </p>
      <div className="fixture-grid">
        {samples.map((s) => (
          <article
            key={s.id}
            className="fixture card"
            lang={s.lang}
            dir={s.dir}
            data-fixture={s.id}
          >
            <h2>{s.label}</h2>
            {s.lines.map((line) => (
              <p key={line} className="fixture-line">
                {line}
              </p>
            ))}
          </article>
        ))}
      </div>
    </section>
  )
}
